import { Injectable } from '@angular/core';
import { PlessHttp } from 'src/app/shared/http/pless-http.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessDialogServiceSub } from 'src/app/commons/kymw00/pless-dialog-service-sub';
import { KYMW7002Model, KYMW1001UserType, KYMW7002SelectorType } from '../kymw7002.model';

import type { GetSuggestionGoodsListCondition } from '../vo/get-suggestion-goods-list-condition.model';

// リクエスト構造
export interface GetSuggestionGoodsListInfoRequest {
  search: {
    SuggestionGoodsList: {
      condition: GetSuggestionGoodsListCondition;
    };
  };
}

// レスポンス構造
export interface GetSuggestionGoodsListInfoResponse {
  /** 総件数 */
  TotalNum: string;
  /** 表示開始件数 */
  StartDispNum: string;
  /** 表示終了件数 */
  EndDispNum: string;
  /** 提案商品一覧 */
  SuggestionGoodsList: {
    /** Pコード */
    PCode: string;
    /** アイテムコード */
    ItemCode: string;
    /** JANコード */
    JanCode: string;
    /** 商品案内用商品名 */
    GuideGoodsName: string;
    /** 商品案内用規格名 */
    GuideStandardName: string;
    /** メーカー名 */
    MakerName: string;
    /** 価格パターン */
    PricePattern: string;
    /** 供給価格（通常） */
    SupplyPriceStandard: number;
    /** 供給価格（特1） */
    SupplyPriceSpecial1: number;
    /** 供給価格（特2） */
    SupplyPriceSpecial2: number;
    /** 今回供給価格 */
    ThisTimeSupplyPriceStandard: number;
    /** 仕入価格（通常） */
    CostPriceStandard: number;
    /** 仕入価格（特1） */
    CostPriceSpecial1: number;
    /** 仕入価格（特2） */
    CostPriceSpecial2: number;
    /** 今回仕入価格 */
    ThisTimeCostPriceStandard: number;
    /** 在庫数 */
    StockNum: number;
    /** 発注単位 */
    OrderUnitType: string;
    /** 新規区分 */
    NewUnitType: string;
    /** 計画数 */
    PlanNum: number;
    /** 注文番号 */
    OrderNum: string;
    /** 備考 */
    Remarks: string;
  }[];
}

/**
 * 提案商品情報一覧 取得サービス
 * @export GetSuggestionGoodsListInfoService
 * @class GetSuggestionGoodsListInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetSuggestionGoodsListInfoService extends PlessJsonResponderSub<GetSuggestionGoodsListInfoResponse> {
  model: KYMW7002Model;
  private requestData: GetSuggestionGoodsListInfoRequest;
  private calbak: (response: GetSuggestionGoodsListInfoResponse) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSuggestionGoodsListInfoService
   */
  private getBody(pageNo: number): PlessRequest {
    // 選定担当区分
    let selectorType;
    if (this.model.userType === KYMW1001UserType.WHOLESALE) {
      selectorType = KYMW7002SelectorType.WHOLESALE;
    } else if (this.model.userType === KYMW1001UserType.PLANNING_SUPPORT) {
      selectorType = KYMW7002SelectorType.PLANNING_SUPPORT;
    }

    // 検索条件を設定
    const condition: GetSuggestionGoodsListCondition = {
      OrderCode: this.model.orderCode,
      MediumType: this.model.mediumType,
      FeatureCode: this.model.featureCode,
      PageNo: pageNo,
      FeatureRequestId: this.model.selectedGoodsFlgResult.FeatureRequestId,
      SelectorType: selectorType,
    };

    // リクエストを設定
    this.requestData = {
      search: {
        SuggestionGoodsList: { condition }
      }
    };

    return new PlessRequest(this.requestData);
  }

  
  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetSuggestionGoodsListInfoService
   */
  execute(model: KYMW7002Model, pageNo: number, f?: (response: GetSuggestionGoodsListInfoResponse) => void): void {
    this.model = model;
    if (f) this.calbak = f;
    this.send('getSuggestionGoodsListInfo', this.getBody(pageNo));
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSuggestionGoodsListInfoService
   */
  success(data: GetSuggestionGoodsListInfoResponse) {
    if (this.calbak) this.calbak(data);
  }
}
